import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupIntersect: React.FC<CentralIconBaseProps> = (
  props,
) => {
  return (
    <CentralIconBase {...props} ariaLabel="boolean-group-intersect">
      <path
        d="M9 5.5V3H21V15H18.5M9 9V15H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M15 15V9H9M5.5 9H3V21H15V18.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconBooleanGroupIntersect;
